import React, { useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CartTale2";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";

function ProfitLossReport() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
  ]);
  const [data] = useState([]);
  const [buttonDataa] = useState([
    {
      buttonText: "Submit",
    },
  ]);

  const [selectButton] = useState([
    // {
    //   placeholder: "Vat",
    // },
  ]);
  return (
    <main>
      <CartTable2
        data={data}
        columns={columns}
        heading={"Profit Loss Report"}
        buttonDataa={buttonDataa}
        selectButton={selectButton}
      />
    </main>
  );
}

export default ProfitLossReport;
